// routing
import Routes from "routes";

// project imports
import Locales from "ui-component/Locales";
import ThemeCustomization from "themes";

// auth provider
import { AuthContextProvider } from "contexts/AuthContext";

// ==============================|| APP ||============================== //

const App = () => (
  <ThemeCustomization>
    <Locales>
      <AuthContextProvider>
        <Routes />
      </AuthContextProvider>
    </Locales>
  </ThemeCustomization>
);

export default App;
